import React from "react";
import JSONLD from "./json-ld";

interface OrganizationProps {
    url: string;
}
export default function JSONLDOrganization({ url }: OrganizationProps): JSX.Element {
    const organizationJsonLD = {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Lyst",
        url,
        sameAs: [
            "https://twitter.com/lyst",
            "https://www.facebook.com/Lyst",
            "https://instagram.com/lyst/",
            "https://plus.google.com/+LYST",
            "https://www.pinterest.com/Lyst/",
            "http://lyst.tumblr.com/",
        ],
    };
    return <JSONLD JSONLD={organizationJsonLD} />;
}
